import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/services/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    siteLanguage: 'ja',
    personId: '',
    doctorName: '',
    filler: '',
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  },
  mutations: {
    setIsLoading (state, val) {
      state.isLoading = val
    },
  	setSiteLanguage (state, val) {
      state.siteLanguage = val
    },
    setPersonId (state, val) {
      state.personId = val
    },
    setDoctorName (state, val) {
      state.doctorName = val
    },
    setFiller (state, val) {
      state.filler = val
    },
    setUser(state, val) {
      if(val.person_id) {
        localStorage.setItem("user", JSON.stringify(val))
      }
      state.user = val
    },
    logout(state) {
      state.user = null
      localStorage.removeItem('user')
    }
  },
  actions: {
    async getUser({ commit, dispatch }, { userId, loading }) {
      loading = loading === false ? false : true
      loading && commit('setIsLoading', true)
      const res = await Api.get(`/user/${userId}`)
      res.data && commit('setUser', res.data)
      loading && commit('setIsLoading', false)
      return res
    }
  },
  modules: {
  }
})